import { useQuery } from 'react-query'

import { defaultStaleTime } from '../../../config/queryClient'
import { QueryKeys } from '../../../enums/queryKeys'
import { ContactBalancePosting, fetchContactBalancePostings } from '../query-api'

interface UseFetchContactBalancePostingsProps {
  originatorReference?: string
  enabled?: boolean
}

interface UseFetchContactBalancePostingsResponse {
  contactBalancePostings: ContactBalancePosting[]
  isLoading: boolean
}

export const useFetchContactBalancePostings = ({
  originatorReference,
  enabled = true,
}: UseFetchContactBalancePostingsProps): UseFetchContactBalancePostingsResponse => {
  const { data, isLoading } = useQuery(
    [QueryKeys.ContactBalancePostings, originatorReference],
    () => fetchContactBalancePostings(originatorReference as string),
    {
      enabled: enabled && !!originatorReference,
      staleTime: defaultStaleTime,
    },
  )

  return {
    contactBalancePostings: data?.contactBalancePostings || [],
    isLoading,
  }
}
